import { render } from "./AddTransfertMagPage.vue?vue&type=template&id=74e7437b&ts=true"
import script from "./AddTransfertMagPage.vue?vue&type=script&lang=ts"
export * from "./AddTransfertMagPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__